import FilterItem from "./component"
import styled from "styled-components"

export default styled(FilterItem)``